import "../_pages";
import { Application } from "@hotwired/stimulus";
import TrackingController from "../stimulus/tracking_controller";
import NavigationController from "../stimulus/navigation_controller";

// stimulus
const application = Application.start();
application.warnings = false;
application.debug = false;
application.register("tracking", TrackingController);
application.register("navigation", NavigationController);
